import Input from "@/ui/input";
import { IconComponent } from "@/ui/icon";
import GradientBorderRadius from "@/ui/gradient-border-radius";
import PositionsFiltersModal from "@/features/filters-modals/positions-filters-modal";
import ExpandHeightButton from "@/ui/expand-height-button";
import { usePositionsFilter } from "@/providers/positions-filter/positions-filter";

const PositionsHeader = ({
  expanded,
  toggleExpanded,
}: {
  expanded?: boolean;
  toggleExpanded?: () => void;
}) => {
  const { searchInput, setSearchInput } = usePositionsFilter();

  return (
    <div className="relative w-full h-[1.375rem] flex justify-between items-center my-[0.625rem] px-[0.625rem]">
      <div className="h-full w-[15.625rem] group">
        <Input
          className="pl-[0.25rem] h-[1.375rem] font-semibold group placeholder:text-white"
          placeholder="Token"
          value={searchInput}
          onChange={setSearchInput}
          rightSide={
            <GradientBorderRadius
              radius="left"
              gradient={
                searchInput && searchInput !== ""
                  ? "reversed-100"
                  : "default-border"
              }
              hover="input-50-right"
            >
              <div className="w-[1.375rem] h-[1.375rem] flex justify-center items-center">
                <IconComponent
                  name="search"
                  className="w-[0.75rem] h-[0.75rem]"
                />
              </div>
            </GradientBorderRadius>
          }
        />
      </div>
      <div className="absolute inset-0 flex justify-center items-center pointer-events-none">
        <div className="text-base leading-[0.625rem] font-semibold">
          Positions
        </div>
      </div>
      <div className="flex gap-x-[0.3125rem] items-center">
        {toggleExpanded && (
          <ExpandHeightButton
            expanded={expanded ?? false}
            toggleExpanded={toggleExpanded}
          />
        )}
        <PositionsFiltersModal />
      </div>
    </div>
  );
};

export default PositionsHeader;
